import Cargando from 'components/Varios/Cargando'
import React, { useEffect, useMemo, useState } from 'react'
import { ObtenerInformacionSolicitudes } from './FunctionsAprobacionSolicitudes'
import TableSolicitudesAprobar from './TableSolicitudesAprobar'
import { SolicitudesPorAprobar, TipoFiltroSolicitudAprobar } from './TypesAprobacionSolicitudes'

type StateAprobacionSolicitudes = {
    filasTabla: SolicitudesPorAprobar[],
    loadingFilas: boolean,
    errorFilas: boolean,
    mensajeAprobacion: string | undefined,
    tipoSolicitud:TipoFiltroSolicitudAprobar
}

export default function AprobacionSolicitudesMarcacion() {

    const TITULO_APROBACION_SOLICITUDES = "APROBACION DE SOLICITUD DE JUSTIFICACIÓN/RECUPERACIÓN DE MARCACIONES ";

    const defaulState: StateAprobacionSolicitudes = {
        filasTabla: [],
        loadingFilas: false,
        errorFilas: false,
        mensajeAprobacion: undefined,
        tipoSolicitud:TipoFiltroSolicitudAprobar.TODOS
    }
    const [stateAprobacion, setstateAprobacion] = useState<StateAprobacionSolicitudes>(defaulState)

    async function ObtenerDatos(tipo:TipoFiltroSolicitudAprobar) {
        setstateAprobacion({ ...stateAprobacion, loadingFilas: true,tipoSolicitud:tipo })
        const resultado = await ObtenerInformacionSolicitudes(tipo)
        if (resultado.status === 200) {

            const tipoFiltro: TipoFiltroSolicitudAprobar = tipo;

            if (typeof (resultado.dataResponse) === "string") {
                setstateAprobacion({ ...stateAprobacion, mensajeAprobacion: resultado.dataResponse, loadingFilas: false,tipoSolicitud:tipoFiltro })

            }
            else{
                setstateAprobacion({ ...stateAprobacion, filasTabla: resultado.dataResponse, loadingFilas: false,tipoSolicitud:tipoFiltro })
         
            }
        }
        else {
            setstateAprobacion({ ...stateAprobacion, loadingFilas: false, errorFilas: true,tipoSolicitud:tipo })
        }

    }

    useEffect(() => {
        //ObtenerDatos(TipoFiltroSolicitudAprobar.TODOS);
        window.location.href = "https://th.espol.edu.ec/directivo/aprobaciondirectivos";
    }
        , [])


    const tablaSolicitudes = useMemo(() => {
        const { loadingFilas, errorFilas, filasTabla,tipoSolicitud } = stateAprobacion
        if (loadingFilas) {
            return <Cargando mensaje='Cargando Solicitudes' />;
        }
        else if (!loadingFilas && errorFilas) {
            return <div>No ha sido posible cargar la información</div>
        }
        else if (filasTabla.length > 0) {
            return (
                <TableSolicitudesAprobar
                    dataprops={stateAprobacion.filasTabla}
                    recargarInformacionTabla={() => ObtenerDatos(tipoSolicitud)}
                    filtrarTiposSolicitud={(tipo: TipoFiltroSolicitudAprobar) => ObtenerDatos(tipo)}
                    tipoFiltroSolicitud={stateAprobacion.tipoSolicitud}
                    Actualizar={() => ObtenerDatos(TipoFiltroSolicitudAprobar.TODOS) }
                />
            )
        }
        else{
            return (
                <TableSolicitudesAprobar
                    dataprops={[]}
                    recargarInformacionTabla={() => ObtenerDatos(tipoSolicitud)}
                    filtrarTiposSolicitud = {(tipo:TipoFiltroSolicitudAprobar) => ObtenerDatos(tipo)}
                    tipoFiltroSolicitud={stateAprobacion.tipoSolicitud}
                    Actualizar={() => ObtenerDatos(TipoFiltroSolicitudAprobar.TODOS)}
                />
            )
        }
    }, [stateAprobacion])


    return (
        <div className="content">
            <div className="titulo_seccion mb-5"> {TITULO_APROBACION_SOLICITUDES} </div>
            {
                <p className='small-error'>{stateAprobacion.mensajeAprobacion} </p>
            }
            {
                tablaSolicitudes
            }

        </div>
    )
}
